import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { cn } from '@/utils/commonUtil'

import styles from './ProgressBar.module.scss'

export const ProgressBar = () => {
  const isNavigating = useIsNavigating()

  return <div className={cn(styles.container, { isNavigating, styles })} />
}
